import CalculationDetailsVersion, { IGetCalculationDetailsVersionDto } from './CalculationDetailsVersion';
import { Guid, IApiLink } from "@/types";
import { ApiLinkEntity, ApiLinkRel } from 'config/constants';

export interface IGetCalculationDetailsVersionsDto {
    entities: IGetCalculationDetailsVersionDto[]
    links?: IApiLink[]
}

export default class CalculationDetailsVersions {
    items: CalculationDetailsVersion[]

    linkCreate?: IApiLink

    constructor(dto: IGetCalculationDetailsVersionsDto) {
        this.items = dto.entities.map(_dto => new CalculationDetailsVersion(_dto))

        this.linkCreate = dto.links?.find(lnk =>
            lnk.entity === ApiLinkEntity.calculationDetailsVersion
            && lnk.rel === ApiLinkRel.new
        )

    }

    provideUserEmails(emails: Record<Guid, string>) {
        this.items.forEach(comment => comment.provideUserEmail(emails[comment.userId]))
    }
}
